/**
 * KpiStatCard — KPI tile for the AI Consumption Console (P3). Wraps the
 * `@garden/ui` `StatTile` primitive; the optional `hint` maps to StatTile's
 * `sub` sub-line (StatTile has no `hint` prop).
 */
import { type ReactElement } from "react";
import { StatTile } from "@garden/ui";

export function KpiStatCard({
  label,
  value,
  hint,
}: {
  label: string;
  value: string;
  hint?: string;
}): ReactElement {
  return (
    <div data-testid="ai-kpi">
      <StatTile label={label} value={value} {...(hint ? { sub: hint } : {})} />
    </div>
  );
}
export default KpiStatCard;
